import { Box, Center, Spinner } from '@chakra-ui/react';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { LotType, ResourceType } from '../../_openapi/portfolio-optimizer';
import { useOpenLots } from '../../api/lot';
import { openLotListColumns } from '../../Lot/openLotListColumns';
import { Pagination } from '../../widgets/Table/Pagination';
import { Table } from '../../widgets/Table/Table';
import { TableControls } from '../../widgets/Table/TableControls';
import { useTableColumnSettings } from '../../widgets/Table/useTableColumnSettings';
import { useTableState } from '../../widgets/Table/useTableState';

export const PortfolioOpenLotsTableTab = ({ pId }: { pId: string }) => {
    const { pagination, setPagination, sorting, setSorting, columnFilters, setColumnFilters } = useTableState({
        columns,
        initialSort: [{ id: 'pnlUnrealized', desc: true }],
        initialFilters: [{ id: 'pId', value: pId }],
    });

    const { data: openLotsPage, isPending } = useOpenLots({ pagination, columnFilters, sorting });

    const { columnVisibility, setColumnVisibility, columnOrder, setColumnOrder } =
        useTableColumnSettings('portfolioOpenLots');

    const table = useReactTable({
        data: openLotsPage?.lots || [],
        columns,
        state: {
            columnVisibility,
            columnOrder,
            pagination,
            sorting,
            columnFilters,
        },
        onColumnFiltersChange: setColumnFilters,
        onColumnVisibilityChange: setColumnVisibility,
        onColumnOrderChange: setColumnOrder,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        manualPagination: true,
        manualSorting: true,
        manualFiltering: true,
        sortDescFirst: false,
    });

    if (isPending) {
        return (
            <Center width="100%" height="40vh">
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="teal.500" size="lg" />
            </Center>
        );
    }

    return (
        <Box>
            <TableControls table={table} resourceType={ResourceType.LOT} metaData={{ lotType: LotType.OPEN }} />
            <Table table={table} allowXOverflow />
            <Pagination table={table} totalItems={openLotsPage?.totalNr} />
        </Box>
    );
};

const EXCLUDE_COLUMNS = ['pId', 'portfolioName', 'householdName', 'portfolioGuid', 'aC'];
const columns = openLotListColumns.filter((col) => col.id && !EXCLUDE_COLUMNS.includes(col.id));
